import type { ChangeEvent } from "react";
import { format, parse } from "date-fns";
import { ptBR } from "date-fns/locale";

const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export function parseIsoDate(value: string): Date | undefined {
  if (!value || !ISO_DATE_PATTERN.test(value)) return undefined;

  const parsed = parse(value, "yyyy-MM-dd", new Date());
  return Number.isNaN(parsed.getTime()) ? undefined : parsed;
}

export function toIsoDate(date: Date): string {
  return format(date, "yyyy-MM-dd");
}

export function todayIsoDate(): string {
  return toIsoDate(new Date());
}

/** Preserve calendar date when sending date-only values as ISO8601DateTime. */
export function dateOnlyToUtcIsoDateTime(dateOnly: string): string {
  if (!ISO_DATE_PATTERN.test(dateOnly)) {
    throw new Error(`Invalid ISO date: ${dateOnly}`);
  }

  return `${dateOnly}T12:00:00.000Z`;
}

export function formatDisplayDate(value: string): string {
  const date = parseIsoDate(value);
  if (!date) return "";
  return format(date, "dd/MM/yyyy", { locale: ptBR });
}

export function createDateChangeEvent(value: string): ChangeEvent<HTMLInputElement> {
  return {
    target: { value } as HTMLInputElement,
    currentTarget: { value } as HTMLInputElement,
  } as ChangeEvent<HTMLInputElement>;
}
